import { Component, Input } from '@angular/core';
import { ConfigInitial } from '../../models';

@Component({
  selector: 'app-loader-full',
  standalone: false,
  templateUrl: './loader-full.component.html',
  styleUrl: './loader-full.component.scss'
})
export class LoaderFullComponent {
   @Input() public configInitial!: ConfigInitial;
}
